import { beginGuestUpgrade } from './guestSession';
import { supabase } from './supabase';
import { navigateOutsideApp } from './appNavigation';
import { rememberAuthFlow } from './authFlowContext';

export async function signInWithOAuth(options) {
  const guest = await beginGuestUpgrade();
  const { guestMode, ...authOptions } = options;
  const authenticate = guest && guestMode === 'link' ? supabase.auth.linkIdentity.bind(supabase.auth) : supabase.auth.signInWithOAuth.bind(supabase.auth);
  const { data, error } = await authenticate({
    ...authOptions,
    options: { ...options.options, skipBrowserRedirect: true },
  });
  if (error) throw error;
  if (!data?.url) throw new Error('Could not start sign-in. Please try again.');
  rememberAuthFlow(options.provider, options.options?.redirectTo);
  navigateOutsideApp(data.url);
  return { data, error: null };
}
